import { ReportsDataService } from '../../shared/reports.data.service';
import { ReportsStructureDataDataService } from './shared/reports-structure-data.data.service';
import { Component, OnInit, Input, OnDestroy, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {
  ReporteTramite,
  TramiteBasico,
  Microproceso,
  Tramite,
  Tarea,
  ColumnaFuenteDatosEstructura,
  BaseControl,
  Const,
  DefaultDocument,
  Static,
  Forma,
  Control,
  Option,
  ConfirmComponent
} from '@app/shared';
import { Logger } from '@app/core';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs/Subscription';
import { ReportsStructureDataFormService } from './shared/reports-structure-data.form.service';
import { FormGroup } from '@angular/forms';
import { find } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { ReportsStructureDataConfig } from './shared/reports-structure-data.config.service';
import { FlowTitle } from '@app/shared/title';
import { HelperFlowService } from '@app/shared/services/helper-flow.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { Subject } from 'rxjs';

// Define las acciones posibles para una tarea o actividad
type actionManage = 'select' | 'run';

const log = new Logger('ReportsStructureComponent');

@Component({
  selector: 'iw-reports-structure-data',
  templateUrl: './reports-structure-data.component.html',
  styleUrls: ['./reports-structure-data.component.scss'],
  providers: [
    ReportsDataService,
    ReportsStructureDataDataService,
    HelperFlowService,
    DragulaService,
    ReportsStructureDataFormService,
  ]
})
export class ReportsStructureDataComponent implements OnInit, OnDestroy {

  // Id del reporte seleccionado
  @Input() idReport = -1;
  // Contiene la informacion de la fuente de dato de la columna
  @Input() dataColumnI: ColumnaFuenteDatosEstructura;
  dataColumn: ColumnaFuenteDatosEstructura;
  // Contiene el campo del formulario seleccionado
  selectFieldForm = '';
  // Contiene el campo interno seleccionado
  selectFieldInternal = '';
  // Contiene el campo de la columna seleccionada de la tabla
  selectFieldFormColumn = '';
  // Pregunta de la modal
  question = '';
  // Contiene la accion a realizar en el fomulario de columnas seleccionadas
  actionForm = 'Agregar';
  // Contiene el id de la tarea seleccionada
  idTaskSelect = -1;
  // Define si muestra o no el contenedor del flujo
  viewFlow = false;
  // Define cuando se esta cargando un flujo
  isLoadingFlow = false;
  // Define cuando mostrar la tabla de las columnas de la tabla seleccionadas
  openTableColumnSelect = false;
  // Define cuando mostrar el formulario de agregar columna
  openFormColumn = false;
  // Define cuando se esta editando una columna seleccionada
  editFormColumn = false;
  // Configuración para generar el título del flujo
  configFlowTitle: Partial<FlowTitle>;
  // Contiene la tarea seleccionada
  taskSelect: Partial<Tarea>;
  // Flujo actual consultado
  flow: TramiteBasico | Microproceso;
  // Contiene la forma de la tarea seleccionada
  formTask: Forma;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Opciones del formulario
  options = {};
  // Configuracion de la tabla
  settings = {};
  // Contiene el registro seleccionado de la tabla de columnas seleccionadas
  rowColumnsSelect = {};
  // Contiene las columnas seleccionadas de la tabla
  columnsSelect: Array<any> = [];
  // Tramites asociados al reporte
  tramitesReports: ReporteTramite[] = [];
  // Historial de consulta del tramite seleccionado
  historyFlow: Array<number> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  controlsColumns: BaseControl<any>[] = [];
  // Contiene los documentos del sistema
  documents: DefaultDocument[] = [];
  // Contiene los campos de laos formularios de la forma de la tarea seleccionada
  fieldsForm: Control[] = [];
  // Contiene los campos de las tablas de la forma de la tarea seleccionada
  fieldsTable: Control[] = [];
  // Contiene el trámite seleccionado
  tramiteSelected: any = null;
  // contiene la acción para la confirmación
  action: string = '';
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelectList') ngSelectList: TemplateRef<any>;
  // Suscripción a las notificaciones de otros componentes
  private notifications: Subscription;
  // Contiene el formulario de la fuente de dato
  private form: FormGroup;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // emite el evento de formulario valido
    @Output() structureDataSouce: EventEmitter<ColumnaFuenteDatosEstructura> = new EventEmitter();
  constructor(
    private rds: ReportsDataService,
    private rsdds: ReportsStructureDataDataService,
    private rsdfs: ReportsStructureDataFormService,
    private hfs: HelperFlowService,
    private ds: DragulaService,
    private ns: NotifierService,
  ) {
    // Si las bolsas ya existen se eliminan previamente antes de volver a crearlas
    if (this.ds.find('bag-activities')) {
      this.ds.destroy('bag-activities');
    }
    if (this.ds.find('bag-tasks')) {
      this.ds.destroy('bag-tasks');
    }

    // Configuraciones para la bolsa de actividades (dragula)
    this.ds.setOptions('bag-activities', {
      moves: (el: any, container: any, handle: any) => {
        return false;
      }
    });
    // Configuraciones para la bolsa de tareas (dragula)
    this.ds.setOptions('bag-tasks', {
      moves: (el: any, container: any, handle: any) => {
        return false;
      }
    });
  }

  async ngOnInit() {
    // Se agrega el template del selector con modal para las opciones de los formularios
    this.options['templateList'] = this.ngSelectList;
    // Se configura la tabla
    const configTable = new ReportsStructureDataConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      log.debug(data);
      this.defineActionTableColumns(data.action, data.data);
    });
    // Consulta los documentos del sistema para la fuente de datos cuando es cpor documento de la tarea
    this.rsdds.getDefaultDocuments().subscribe(data => {
      this.documents = data;
      this.options['documents'] = this.documents;
    });
    // Se validad si hay un reporte seleccionado para consultar los tramites asociados de este
    if (this.idReport !== -1) {
      this.rds.getReportsTramites(this.idReport).subscribe(data => {
        if (data && data.length) {
          this.tramitesReports = data;
        }
      });
    }
    // Se valida si ya hay una tarea seleccinada para cargar esta
    if (this.dataColumnI && this.dataColumnI.id_tarea) {
      this.loadingData();
    }
    // Escuchar todas las notificaciones de los elementos hijos del flujo
    this.notifications = this.ns.get().subscribe(async n => {
      // Si se ejecutó el evento click en una tarea
      if (n.source === 'task') {
        let action: actionManage;
        // Definir la acción que se quiere hacer con la tarea
        switch (n.action) {
          case 'selectTask':
              action = 'select';
              this.taskSelect = n.data.task;
              this.idTaskSelect = n.data.task.id;
              this.historyFlow = [];
              this.viewFlow = false;
              this.isLoadingFlow = false;
              this.flow = null;
              this.configFlowTitle = null;
              if (
                n.data.task &&
                n.data.task.tarea_tipo &&
                n.data.task.tarea_tipo.nombre &&
                n.data.task.tarea_tipo.nombre === Const.TYPES_TASK.form
              ) {
                if (n.data.task.tarea_forma && n.data.task.tarea_forma.length) {
                  await this.rsdds.getFormTask(n.data.task.tarea_forma[0].id_forma).then(form => {
                    this.formTask = form;
                    this.loadingFieldsForm(this.formTask);
                  }).catch((err) => {
                    log.debug(err);
                    this.formTask = null;
                    this.loadingFieldsForm(this.formTask);
                  });
                }
              }
              this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl);
              this.loadingColumnsSelect([]);
              this.form = null;
              log.debug(n);
            break;
          case 'runMicroProcess':
            action = 'run';
            this.defineAction('openMicroProcess', n.data.task.id);
            log.debug(n);
            break;
        }
      }
    });
  }

  ngOnDestroy() {
    this.notifications.unsubscribe();
    this.destroy.next();
    this.destroy.complete();
  }

  trigger(callback: any, ...args: any[]) {
    return callback(...args);
  }

  /**
   * Define la accion a realizar en el flujo
   *
   * @param {('goBack' | 'reload' | 'open' | 'openMicroProcess')} [action='goBack']
   * @param {*} [data]
   * @memberof ReportsStructureDataComponent
   */
  defineAction(action: 'goBack' | 'reload' | 'open' | 'openMicroProcess' | 'remove' = 'goBack', data?: any) {
    switch (action) {
      case 'reload':
        if (this.historyFlow.length > 1) {
          this.runMicroProcess(this.historyFlow[this.historyFlow.length - 1], true);
        } else {
          this.loadingTramite(this.historyFlow[0]);
        }
        break;
      case 'open':
        this.tramiteSelected = data;
        this.options['tramiteSelected'] = this.tramiteSelected.nombre_tramite;
        this.loadingTramite(data);
        break;
      case 'openMicroProcess':
        if (data) {
          this.runMicroProcess(data);
        }
        break;
      case 'remove':
        this.question = 'Esta acción eliminará la información de la configuración de la tarea seleccionada. ¿Realmente desea continuar?'
        this.action = action;
        this.confirm.open();
        break;
      default:
        if (this.historyFlow.length > 1) {
          this.historyFlow.pop();
        }
        if (this.historyFlow.length > 1) {
          this.runMicroProcess(this.historyFlow[this.historyFlow.length - 1], true);
        } else {
          this.loadingTramite(this.historyFlow[0]);
        }
        break;
    }
  }

  /**
   * Controla las acciones a realizar en la tabla de seleccionar columnas de las tablas de la tarea
   *
   * @memberof ReportsStructureDataComponent
   */
  defineActionTableColumns(action: 'add' | 'update' | 'delete' | 'close' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.actionForm = 'Agregar';
        this.openFormColumn = true;
        this.editFormColumn = false;
        this.controlsColumns = this.rsdfs.getFormColumns(
          this.options,
          this.ngSelectTpl
        );
        break;
      case 'update':
        this.actionForm = 'Modificar';
        this.selectFieldFormColumn = data.nombre_campo;
        this.openFormColumn = true;
        this.editFormColumn = true;
        this.rowColumnsSelect = data;
        const field = find(this.fieldsTable, {nombre_campo: data.nombre_campo});
        if (field && field.tipo_campo && field.tipo_campo.nombre === 'ngSelect') {
          const positions: Option[] = [];
          if (
            field.propiedades &&
            field.propiedades['columnas_seleccionadas'] &&
            field.propiedades['columnas_seleccionadas'].length
          ) {
            field.propiedades['columnsSelectorModal'].forEach((colSel: string, index: number) => {
              positions.push(
                {key: String(index), value: colSel['label']}
              );
            });
          }
          this.options['listPositionsColumns'] = positions;
        } else {
          this.options['listPositionsColumns'] = [];
        }
        this.controlsColumns = this.rsdfs.getFormColumns(
          this.options,
          this.ngSelectTpl,
          data,
          data.tipo === 'ngSelect'
        );
        break;
      case 'delete':
        this.question = '¿Realmente desea eliminar el registro de la columna seleccionada?';
        this.rowColumnsSelect = data;
        this.confirm.open();
        break;
      case 'close':
        this.actionForm = 'Agregar';
        this.selectFieldFormColumn = '';
        this.openFormColumn = false;
        this.editFormColumn = false;
        this.rowColumnsSelect = {};
        this.controlsColumns = [];
        this.options['listPositionsColumns'] = [];
        break;

    }
  }

  /**
   * Guarda la instancia del formulario creado de la fuente de dato
   *
   * @param {FormGroup} form
   * @memberof ReportsStructureDataComponent
   */
  savedCreatedForm(form: FormGroup) {
    this.form = null;
    this.form = form;
  }

  /**
   * Controla los cambios en el formulario de agregar una fuente de dato
   *
   * @param {*} data
   * @memberof ReportsStructureDataComponent
   */
  changeForm(data: any) {
    if (data.change.cboTipoDato === 'campo_forma') {
      this.selectFieldInternal = '';
      if (data.change.cboTipoFormulario === 'formulario') {
        this.openTableColumnSelect = false;
        if (data.change.cboCampo !== this.selectFieldForm) {
          this.selectFieldForm = data.change.cboCampo;
          const tempData = this.returnDataSource(true);
          this.options['listPositions'] = [];
          if (tempData) {
            tempData.campo_forma = [this.selectFieldForm];
            if (this.selectFieldForm) {
              const field = find(this.fieldsForm, {nombre_campo: this.selectFieldForm});
              if (field && field.tipo_campo && field.tipo_campo.nombre === 'ngSelect') {
                const positions: Option[] = [];
                if (
                  field.propiedades &&
                  field.propiedades['columnas_seleccionadas'] &&
                  field.propiedades['columnas_seleccionadas'].length
                ) {
                  field.propiedades['columnsSelectorModal'].forEach((colSel: string, index: number) => {
                    positions.push(
                      {key: String(index), value: colSel['label']}
                    );
                  });
                }
                this.options['listPositions'] = positions;
                this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl, tempData, true);
                this.loadingColumnsSelect([]);
              } else {
                this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl, tempData);
                this.loadingColumnsSelect([]);
              }
            } else {
              this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl, tempData);
              this.loadingColumnsSelect([]);
            }
          }
        }
      } else if (data.change.cboTipoFormulario === 'tabla') {
        this.selectFieldForm = '';
        this.openTableColumnSelect = true;
      } else {
        this.openTableColumnSelect = false;
        this.selectFieldForm = '';
      }
    } else if (data.change.cboTipoDato === 'campo_interno') {
      this.selectFieldForm = '';
      if (data.change.cboCampoInterno !== this.selectFieldInternal) {
        this.selectFieldInternal = data.change.cboCampoInterno;
        const tempData = this.returnDataSource(true);
        this.options['parametersInternal'] = [];
        if (tempData) {
          if (this.selectFieldInternal) {
            tempData.campo_interno = this.selectFieldInternal.split('_');
            if (Const.EXCEPTION_PARAMETERS_FIELD_INTERNAL.indexOf(this.selectFieldInternal) === -1) {
              if (Const.PARAMETERS_FIELD_INTERNAL[this.selectFieldInternal]) {
                this.options['parametersInternal'] = Const.PARAMETERS_FIELD_INTERNAL[this.selectFieldInternal];
              } else {
                this.options['parametersInternal'] = Const.PARAMETERS_FIELD_INTERNAL.general;
              }
            }
          } else {
            tempData.campo_interno = '';
          }
        }
        if (tempData) {
          this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl, tempData);
        } else {
          this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl);
        }
      }
    } else {
      this.openTableColumnSelect = false;
      this.selectFieldForm = '';
      this.selectFieldInternal = '';
    }
  }

  /**
   * Controla los cambios en el formulario de agregar o editar columna seleccionada
   *
   * @param {*} data
   * @memberof ReportsStructureDataComponent
   */
  changeFormColumns(data: any) {
    if (data && data.change) {
      if (data.change.cboCampoTabla !== this.selectFieldFormColumn) {
        this.selectFieldFormColumn = data.change.cboCampoTabla;
        this.options['listPositionsColumns'] = [];
        const field = find(this.fieldsTable, {nombre_campo: this.selectFieldFormColumn});
        if (field && field.tipo_campo && field.tipo_campo.nombre === 'ngSelect') {
          const positions: Option[] = [];
          if (
            field.propiedades &&
            field.propiedades['columnas_seleccionadas'] &&
            field.propiedades['columnas_seleccionadas'].length
          ) {
            field.propiedades['columnsSelectorModal'].forEach((colSel: string, index: number) => {
              positions.push(
                {key: String(index), value: colSel['label']}
              );
            });
          }
          this.options['listPositionsColumns'] = positions;
        }
        this.controlsColumns = this.rsdfs.getFormColumns(
          this.options,
          this.ngSelectTpl,
          {nombre_campo: this.selectFieldFormColumn},
          field ? field.tipo_campo.nombre === 'ngSelect' ? true : false : false
        );
      }
    }
  }

  /**
   * Retorna el objeto de la fuente de dato
   *
   * @param {boolean} [skipValidForm=false]
   * @returns {(ColumnaFuenteDatosEstructura | false)}
   * @memberof ReportsStructureDataComponent
   */
  returnDataSource(skipValidForm: boolean = false): ColumnaFuenteDatosEstructura | false {
    const source: ColumnaFuenteDatosEstructura = {};
    if (this.idTaskSelect !== -1) {
      if (this.form && (this.form.valid || skipValidForm)) {
        source.id_tarea = this.idTaskSelect;

        if (
          this.taskSelect &&
          this.taskSelect.tarea_tipo &&
          this.taskSelect.tarea_tipo.nombre &&
          this.taskSelect.tarea_tipo.nombre === Const.TYPES_TASK.form &&
          !this.taskSelect.tarea_forma[0].forma_especifica
        ) {
          source.id_forma = this.taskSelect.tarea_forma[0].id_forma;
        } else if (this.dataColumn && this.dataColumn.id_forma && this.dataColumn.id_tarea === this.idTaskSelect) {
          source.id_forma = this.dataColumn.id_forma;
        }

        switch (this.form.value['cboTipoDato']) {
          case 'campo_interno':
            source.campo_interno = this.form.value['cboCampoInterno'];
            if (this.form.value['cboParametroInterno']) {
              source.campo_interno += '_' + this.form.value['cboParametroInterno'];
            }
            break;
          case 'documento':
            source.tarea_documento = this.form.value['cboParametroDocumento'] + '|' + this.form.value['cboDocumento'];
            break;
          case 'campo_forma':
            switch (this.form.value['cboTipoFormulario']) {
              case 'formulario':
                source.campo_forma = this.form.value['cboCampo'];
                let cols = '';
                if (this.form.value['cboListCampoForm'] && this.form.value['cboListCampoForm'].length) {
                  this.form.value['cboListCampoForm'].forEach((column: string, index: number) => {
                    if (index === 0) {
                      cols += column;
                    } else {
                      cols += '|' + column;
                    }
                  });
                }
                source.campo_forma += '|' + cols;
                break;
              case 'tabla':
                let columns = '';
                if (this.columnsSelect && this.columnsSelect.length) {
                  this.columnsSelect.forEach((el, index) => {
                    if (index === 0) {
                      columns += el['nombre_campo'];
                    } else {
                      columns += '|' + el['nombre_campo'];
                    }
                    if (el['posiciones'] && el['posiciones'].length) {
                      el['posiciones'].forEach((col: string) => {
                        columns += '/' + col;
                      });
                    }
                  });
                }
                source.campo_tabla = columns;
                break;
            }
            break;
        }
        this.structureDataSouce.emit(source);
        return source;
      } else {
        this.structureDataSouce.emit(null);
        return false;
      }
    } else {
      this.structureDataSouce.emit(source);
      return source;
    }
  }

  /**
   * Controla las acciones realizadas en el modal de confirmaciones
   *
   * @param {boolean} resp
   * @memberof ReportsStructureDataComponent
   */
  actionComfirm(resp: boolean) {
    if (resp && this.action !== 'remove' && this.action !== 'changeTask') {
      this.deleteColumnSelect();
    }else if(resp && this.action == 'remove'){
      this.taskSelect = null;
      this.idTaskSelect = -1;
      this.historyFlow = [];
      this.viewFlow = false;
      this.isLoadingFlow = false;
      this.flow = null;
      this.configFlowTitle = null;
      this.openTableColumnSelect = false;
      this.selectFieldForm = '';
      this.selectFieldInternal = '';
      this.options['parametersInternal'] = [];
      this.tramiteSelected = null;
    }else if(resp && this.action == 'changeTask'){
      this.taskSelect = null;
      this.loadingTramite(this.tramiteSelected);
    }
  }

  /**
   * Guarda o modifica el registro de la columna seleccionada
   *
   * @param {*} data
   * @memberof ReportsStructureDataComponent
   */
  saveColumnsSelect(data: any) {
    const field = find(this.fieldsTable, {nombre_campo: data.cboCampoTabla});
    const fieldSelect = {
      nombre_campo: data.cboCampoTabla
    };
    if (field) {
      fieldSelect['nombre'] = field.label;
      fieldSelect['tipo'] = field.tipo_campo.nombre;
      fieldSelect['formulario'] = field['formulario'];
      if (field.tipo_campo.nombre === 'ngSelect') {
        fieldSelect['posiciones'] = data.cboListCampoForm;
      }
    }
    if (this.editFormColumn) {
      this.columnsSelect[this.rowColumnsSelect['index']] = fieldSelect;
    } else {
      this.columnsSelect.push(fieldSelect);
    }
    this.defineActionTableColumns('close');
    this.loadingTableColumns();
  }

  /**
   * Carga el flujo del tramite seleccionado
   *
   * @private
   * @param {(ReporteTramite | number)} selectTramite
   * @memberof ReportsStructureDataComponent
   */
  private async loadingTramite(selectTramite: ReporteTramite | number) {
    if (selectTramite) {
      const idTramite = (typeof selectTramite === 'object') ? selectTramite.tramite : selectTramite;
      log.debug('id_tramite', selectTramite);
      this.isLoadingFlow = true;
      this.historyFlow = [idTramite];
      log.debug('history', this.historyFlow);
      this.viewFlow = true;
      await this.rsdds.getDefaultTramite(idTramite)
        .then(data => {
          this.flow = data;
          this.flow.actividades = this.hfs.refineActivities(this.flow.actividades);
          log.debug('flow', this.flow);
          this.isLoadingFlow = false;
          this.configFlowTitle = this.hfs.getFlowTitle(<Tramite>this.flow);
          this.configFlowTitle.lengthFlowsHistory = this.historyFlow.length;
        })
        .catch((err) => {
          this.isLoadingFlow = false;
          log.debug(err);
        });
    } else {
      this.historyFlow = [];
      this.viewFlow = false;
      this.isLoadingFlow = false;
      this.flow = null;
      this.configFlowTitle = null;
    }
  }

  /**
   * Carga el flujo del microproceso seleccionado
   *
   * @private
   * @param {number} idMicroProcess
   * @param {boolean} [refresh=false]
   * @memberof ReportsStructureDataComponent
   */
  private async runMicroProcess(idMicroProcess: number, refresh: boolean = false) {
    if (idMicroProcess) {
      this.isLoadingFlow = true;
      await this.rsdds.getDefaultMicroProces(idMicroProcess)
        .then(data => {
          log.debug('id_microproceso', idMicroProcess);
          if (!refresh) {
            this.historyFlow.push(idMicroProcess);
          }
          log.debug('history', this.historyFlow);
          this.flow = data;
          this.flow.actividades = this.hfs.refineActivities(this.flow.actividades);
          log.debug('flow', this.flow);
          this.isLoadingFlow = false;
          this.configFlowTitle = this.hfs.getFlowTitle(this.flow);
          this.configFlowTitle.lengthFlowsHistory = this.historyFlow.length;
        })
        .catch((err) => {
          this.isLoadingFlow = false;
          log.debug(err);
        });
    }
  }

  /**
   * Carga para los selectores las dos listas de los campos de formulario y las columnas de la tabla
   * de la forma de la tarea seleccionada
   *
   * @private
   * @param {Forma} form
   * @memberof ReportsStructureDataComponent
   */
  private loadingFieldsForm(form: Forma) {
    this.fieldsForm = [];
    this.fieldsTable = [];
    if (form && form.sub_formas && form.sub_formas.length) {
      form.sub_formas.forEach(subForm => {
        if (subForm.campos && subForm.campos.length) {
          subForm.campos.forEach(field => {
            field['formulario'] = subForm.nombre;
            field['filter'] = field.label + ' ' + field['formulario'] + ' ' + field.tipo_campo.nombre;
            if (subForm.tabla) {
              this.fieldsTable.push(field);
            } else {
              this.fieldsForm.push(field);
            }
          });
        }
      });
    }
    this.options['optionsCampos'] = this.fieldsForm;
    this.options['optionsColumns'] = this.fieldsTable;
  }

  /**
   * Carga la informacion de la tabla de las columnas seleccionadas de la tabla
   *
   * @private
   * @param {string[]} columns
   * @memberof ReportsStructureDataComponent
   */
  private loadingColumnsSelect(columns: string[]) {
    this.columnsSelect = [];
    if (columns.length) {
      columns.forEach(el => {
        let nameField = '';
        const colSelect = el.split('/');
        if (colSelect.length && colSelect.length > 1) {
          nameField = colSelect[0];
        } else {
          nameField = el;
        }
        colSelect.shift();
        const field = find(this.fieldsTable, {nombre_campo: nameField});
        if (field) {
          const fielColumnSelect = {
            nombre: field.label,
            nombre_campo: nameField,
            tipo: field.tipo_campo.nombre,
            formulario: field['formulario'],
            posiciones: colSelect
          };
          this.columnsSelect.push(fielColumnSelect);
        }
      });
    }
    this.loadingTableColumns();
  }

  /**
   * Refresca la data de los registros de la tabla de columnas seleccionadas
   *
   * @private
   * @memberof ReportsStructureDataComponent
   */
  private loadingTableColumns() {
    if (this.columnsSelect && this.columnsSelect.length) {
      this.columnsSelect.forEach((col, index) => {
        col.index = index;
      });
    }
    this.sourceData = new LocalDataSource(this.columnsSelect);
    this.sourceData.refresh();
  }

  /**
   * Elimina el registro seleccionado de las columnas seleccionadas de la tabla
   *
   * @private
   * @memberof ReportsStructureDataComponent
   */
  private deleteColumnSelect() {
    this.columnsSelect.splice(this.rowColumnsSelect['index'], 1);
    this.question = '';
    this.rowColumnsSelect = {};
    this.loadingTableColumns();
  }

  /**
   * Carga la informacion de la fuente de dato para el campo
   *
   * @private
   * @memberof ReportsStructureDataComponent
   */
  private async loadingData() {
    this.dataColumn = Static.copyObjet(this.dataColumnI);
    this.idTaskSelect = this.dataColumn.id_tarea;
    await this.rsdds.getTask(this.dataColumn.id_tarea).then(async data => {
      let columnsSelect = false;
      // Se separan las opciones de los campos de los formularios
      if (this.dataColumn.campo_forma && typeof this.dataColumn.campo_forma === 'string') {
        this.dataColumn.campo_forma = this.dataColumn.campo_forma.split('|');
        if (this.dataColumn.campo_forma.length > 1) {
          columnsSelect = true;
        }
        this.selectFieldForm = this.dataColumn.campo_forma[0];
        this.openTableColumnSelect = false;
      }
      this.taskSelect = data;
      // Se consulta la forma y se organizan los campos en las opciones
      if (this.dataColumn.id_forma) {
        await this.rsdds.getFormTask(this.dataColumn.id_forma).then(form => {
          this.formTask = form;
          this.loadingFieldsForm(this.formTask);
          if (typeof this.dataColumn.campo_forma === 'string') {

          }
          if (
            this.dataColumn.campo_forma &&
            this.dataColumn.campo_forma.length
          ) {
            const field = find(this.fieldsForm, { nombre_campo: this.dataColumn.campo_forma[0] });
            if (field && field.tipo_campo && field.tipo_campo.nombre === 'ngSelect') {
              const positions: Option[] = [];
              if (
                field.propiedades &&
                field.propiedades['columnas_seleccionadas'] &&
                field.propiedades['columnas_seleccionadas'].length
              ) {
                field.propiedades['columnsSelectorModal'].forEach((colSel: string, index: number) => {
                  positions.push(
                    { key: String(index), value: colSel['label']}
                  );
                });
              }
              this.options['listPositions'] = positions;
            } else {
              this.options['listPositions'] = [];
            }
          }
        }).catch((err) => {
          log.debug(err);
          this.formTask = null;
          this.loadingFieldsForm(this.formTask);
        });
      }
      // Se separa el parametro del nombre del documento
      if (this.dataColumn.tarea_documento && typeof this.dataColumn.tarea_documento === 'string') {
        this.dataColumn.tarea_documento = this.dataColumn.tarea_documento.split('|');
      }
      // Se separa el parametro del nombre del documento
      if (this.dataColumn.campo_interno && typeof this.dataColumn.campo_interno === 'string') {
        this.dataColumn.campo_interno = this.dataColumn.campo_interno.split('_');
        this.selectFieldInternal = this.dataColumn.campo_interno[0];
        if (Const.EXCEPTION_PARAMETERS_FIELD_INTERNAL.indexOf(this.dataColumn.campo_interno[0]) === -1) {
          if (Const.PARAMETERS_FIELD_INTERNAL[this.dataColumn.campo_interno[0]]) {
            this.options['parametersInternal'] = Const.PARAMETERS_FIELD_INTERNAL[this.dataColumn.campo_interno[0]];
          } else {
            this.options['parametersInternal'] = Const.PARAMETERS_FIELD_INTERNAL.general;
          }
        } else {
          this.options['parametersInternal'] = [];
        }
      }
      // Se separan las opciones de los campos en tabla
      if (this.dataColumn.campo_tabla && typeof this.dataColumn.campo_tabla === 'string') {
        this.dataColumn.campo_tabla = this.dataColumn.campo_tabla.split('|');
        this.loadingColumnsSelect(this.dataColumn.campo_tabla);
        this.openTableColumnSelect = true;
      }
      // Se crean los controles del formulario
      this.controls = this.rsdfs.getForm(this.options, this.ngSelectTpl, this.dataColumn, columnsSelect);
    }).catch((err) => {
      this.taskSelect = null;
      log.debug(err);
    });
  }


  /**
   *Recarga el flujo con el trámite seleccionado
   *
   * @memberof ReportsStructureDataComponent
   */
  changeTask(){
    this.question = 'Esta acción eliminará la información de la configuración de la tarea seleccionada. ¿Realmente desea continuar?'
    this.action = 'changeTask';
    this.confirm.open();
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/reports-structure-data/reports-structure-data.component.ts